// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1d836bd9","453":"26f8d08f","455":"bf4546f9","977":"07603a27"}[chunkId] + ".chunk.js";
};